<template>
  <div class="banner">
    <div class="open" @click="clickOpenHandler">打开APP</div>
  </div>
</template>

<script>
import {openAppSnail} from 'nw-app-snail'
export default {
  name: 'banner',
  props: {
    click: Function
  },
  methods: {
    clickOpenHandler(){
      if(this.click && typeof this.click === 'function'){
        this.click();
      }else{
        openAppSnail()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .banner{
    position: fixed;
    z-index: 100;
    left: 0;
    top: 0;
    right: 0;
    height: 1.44rem;
    background: #fff url(../images/top_info_bar@3x.png) left center no-repeat;
    background-size: 3.86rem 1.44rem;
    .open{
      position: absolute;
      display: block;
      width: 1.7rem;
      height: .72rem;
      line-height: .72rem;
      background: #B89477;
      border-radius: .72rem;
      right: .3rem;
      top: .35rem;
      color: #FFF;
      font-size: .26rem;
      text-align: center;
    }
  }
</style>
